'use strict';
var processInclude = require('BASE/util');
var sortStoragePrefix = 'search-sort:';
var restoringSort = false;

function getSortStorageKey() {
    var pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('srule');
    return sortStoragePrefix + pageUrl.pathname + pageUrl.search;
}

function clearStoredSort() {
    sessionStorage.removeItem(getSortStorageKey());
}

function isBackNavigation() {
    if (window.performance && window.performance.navigation && window.performance.navigation.type === 1) {
        return false;
    }

    var navigationEntries = window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType('navigation')
        : [];

    return navigationEntries.length && navigationEntries[0].type === 'back_forward';
}

function isReloadNavigation() {
    if (window.performance && window.performance.navigation && window.performance.navigation.type === 1) {
        return true;
    }

    var navigationEntries = window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType('navigation')
        : [];

    return navigationEntries.length && navigationEntries[0].type === 'reload';
}

function resetSortSelection() {
    var $sortSelect = $('[name=sort-order]');
    var $defaultOption = $sortSelect.find('option[selected]').first();

    if ($defaultOption.length) {
        $sortSelect[0].selectedIndex = $defaultOption.index();
        $sortSelect.val($defaultOption.val());
    } else {
        $sortSelect[0].selectedIndex = 0;
    }
}

function restoreSort() {
    if (!$('[name=sort-order]').length) {
        return;
    }

    var storedSortUrl = sessionStorage.getItem(getSortStorageKey());
    if (!storedSortUrl) {
        return;
    }

    var sortUrl = new URL(storedSortUrl, window.location.href);
    var selectedRule = sortUrl.searchParams.get('srule');

    if (!selectedRule || restoringSort) {
        return;
    }

    $('[name=sort-order] option[data-id="' + selectedRule + '"]').prop('selected', true);
    restoringSort = true;
    $.ajax({
        url: storedSortUrl,
        data: { selectedUrl: storedSortUrl },
        method: 'GET',
        success: function (response) {
            $('.product-grid').empty().html(response);
        },
        complete: function () {
            restoringSort = false;
        }
    });
}
/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {    
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    if(selector === '.refinements'){
        if (!$('#refinement-paese button.selected:contains("Italia")').length) {
            $(selector)
            .find('[data-controls="refinement-regione"], [data-controls="refinement-provincia"]')
            .closest('.col-12')
            .hide();        
        }
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

$(document).ready(function () {    
    if (!$('#refinement-paese button.selected:contains("Italia")').length) {
        $('.refinements')
        .find('[data-controls="refinement-regione"], [data-controls="refinement-provincia"]')
        .closest('.col-12')
        .hide();
    }    
    if (!isBackNavigation()) {
        clearStoredSort();
        resetSortSelection();
    }

});

$(window).on('pageshow', function (event) {
    var isBack = !isReloadNavigation() && (event.originalEvent.persisted || isBackNavigation());

    if (isBack) {
        restoreSort();
    } else {
        clearStoredSort();
        resetSortSelection();
    }
});



module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            var selectedUrl = this.value;
            $.spinner().start();
            $(this).trigger('search:sort', selectedUrl);
            $.ajax({
                url: selectedUrl,
                data: { selectedUrl: selectedUrl },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    var sortUrl = new URL(selectedUrl, window.location.href);
                    var selectedRule = sortUrl.searchParams.get('srule');

                    if (selectedRule) {
                        sessionStorage.setItem(getSortStorageKey(), selectedUrl);
                    }

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                clearStoredSort();
                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }
};
